var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showBackNav)?_c('BackNavBar',{attrs:{"title":_vm.backTitle}}):_vm._e(),_c('section',{staticClass:"main-content",class:{ 'login-page-content': !_vm.showNavBar }},[_c('router-view')],1),(_vm.showNavBar)?_c('NavBar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }